import { useMedia } from '@mygpt/app/utils';
import { SessionListParam } from '@mygpt/types';

import { DesktopView } from './ChatContentBottomButton/DesktopView';
import { MobileView } from './ChatContentBottomButton/MobileView';
import FeedbackModal from '@mygpt/app/chat/components/FeedbackButton/FeedbackModal';
import { useFeedbackModal } from '@mygpt/app/chat/hooks/useFeedbackModal';
import { useMatch } from 'react-router-dom';

export interface ChatContentBottomButtonsProps {
  // 消息相关
  item: SessionListParam;
  id: string;
  sessionId: string;
  pageSource: 'widget' | 'playground' | 'share';

  // TTS 相关
  enableTTS: boolean;
  isPlaying?: boolean;
  ttsLoading: boolean;
  onTTSPlayOrPause: (text: string) => void;

  // 交互相关
  copied: boolean;
  setCopied: (copied: boolean) => void;
  handleMessages: (obj: { rating: number; messageId: string }) => void;

  // 样式相关
  floatingActions?: boolean;
}

const Modal = (props: ChatContentBottomButtonsProps) => {
  const { modalType, opened, closeModal, currentMessageInfo } = useFeedbackModal();

  // 如果当前消息的 messageId 与 currentMessageInfo.messageId 不一致，则不渲染，防止页面里渲染了太多 Modal
  if (props.item.messageId !== currentMessageInfo.messageId) {
    return null;
  }

  return <FeedbackModal type={modalType} opened={opened} onClose={closeModal} handleMessages={props.handleMessages} />;
};

export const ChatContentBottomButton: React.FC<ChatContentBottomButtonsProps> = (props) => {
  const match = useMatch('/widget/:botId');
  const isWidgetPage = !!match;

  const { isMobile } = useMedia();

  // 移动端布局
  // 并且不能是 widget 页面，widget 页面还使用和桌面端一样的布局。
  if (isMobile && !isWidgetPage) {
    return (
      <>
        <MobileView {...props} />
        <Modal {...props} />
      </>
    );
  }

  return (
    <>
      <DesktopView {...props} />
      <Modal {...props} />
    </>
  );
};
